import React, { Component } from 'react';

class DAZNCongrats extends Component {
    constructor(props) {
        super(props);

        let storageState = {};
        if(localStorage.nonWinner && localStorage.nonWinner !== 'undefined') {
            storageState.nonWinner = localStorage.nonWinner;
        }
        if(localStorage.promoCode && localStorage.promoCode !== 'undefined') {
            storageState.promoCode = localStorage.promoCode;
        }
        if(localStorage.daznLocation && localStorage.daznLocation !== 'undefined') {
            storageState.locationCopy = localStorage.daznLocation;
        }
        if(localStorage.daznOffer && localStorage.daznOffer !== 'undefined') {
            storageState.offerCopy = localStorage.daznOffer;
        }
        if(localStorage.daznDirections && localStorage.daznDirections !== 'undefined') {
            storageState.directionsCopy = localStorage.daznDirections;
        }
        if(localStorage.daznHeader && localStorage.daznHeader !== 'undefined') {
            storageState.headerCopy = localStorage.daznHeader;
        }

        this.state = {
            nonWinner: false,
            promoCode: null,
            locationCopy: null,
            offerCopy: null,
            directionsCopy: null,
            headerCopy: null,
            ...storageState
        };
    }

    render() {
        const nonWinner = this.state.nonWinner == "true" ? true : false
        const promoCode = this.state.promoCode;
        const locationCopy = this.state.locationCopy;
        const offerCopy = this.state.offerCopy;
        const directionsCopy = this.state.directionsCopy;
        const headerCopy = this.state.headerCopy;

        const _parseCopy = copyText => {
            if(copyText === undefined || copyText === null || copyText === "null") {
                return (<h1></h1>);
            }

            let i = copyText.indexOf("{{{");
            if(i === -1) {
                return (<h1>{copyText !== undefined && copyText !== null && copyText !== "null" ? copyText : ' '}</h1>);
            }

            let current=[];
            let currentType = 1;
            let start=0, len=copyText.length;
            while(start < len) {
                if(start < i) {
                    if(currentType === 1) {
                        current.push(<h1>{copyText.substring(start, i)}</h1>);
                    } else {
                        current.push(<h2>{copyText.substring(start, i)}</h2>);
                    }
                }
                if(i === len) {
                    start = i;
                } else if(copyText.substr(i, '{{{LF}}}'.length).toUpperCase() === '{{{LF}}}') {
                    current.push(<br/>);
                    start = i + '{{{LF}}}'.length;
                    i = copyText.indexOf("{{{", start);
                } else if(copyText.substr(i, '{{{COLOR-START}}}'.length).toUpperCase() === '{{{COLOR-START}}}') {
                    currentType = 2;
                    start = i + '{{{COLOR-START}}}'.length;
                    i = copyText.indexOf("{{{", start);
                } else if(copyText.substr(i, '{{{COLOR-END}}}'.length).toUpperCase() === '{{{COLOR-END}}}') {
                    currentType = 1;
                    start = i + '{{{COLOR-END}}}'.length;
                    i = copyText.indexOf("{{{", start);
                }
                if(i === -1) {
                    i = len;
                }
            }

            return current;
        }

        return (
            <div className="genericAppInner">
                <div className="page daznBackground">
                    <div className="verticalWrap contentWrap">
                        { !nonWinner && // winner
                            <div className="daznInnerWrap">
                                <h1 className="winnerHeader">{headerCopy !== undefined && headerCopy !== null && headerCopy !== "null" ? headerCopy : ' '}</h1>
                                <div className="winnerUnderline" />
                                <h1 className="winnerPrizeCopy">{offerCopy !== undefined && offerCopy !== null && offerCopy !== "null" ? offerCopy : ' '}</h1>
                                <div className="winnerLogo">
                                    <img src={"https://s3-us-west-2.amazonaws.com/contest.fanup.io/dazn.png"} alt="" />
                                </div>
                                <h1 className="thankYouCopy">Thank You!</h1>
                                <h1 className="useCodeCopy">Use Code:</h1>
                                <h1 className={promoCode !== undefined && promoCode !== null && promoCode !== "null" ? "promoCode" : "noPromoCode"}>
                                    {promoCode !== undefined && promoCode !== null && promoCode !== "null" ? promoCode : ' '}
                                </h1>
                                <div className="winnerRedeemCopy">
                                    {_parseCopy(directionsCopy)}
                                </div>
                                <div className="winnerLocationCopy">
                                    {_parseCopy(locationCopy)}
                                </div>
                                <div className="ios">
                                    <a href="https://apple.co/2Ubz68u">
                                        <img src="https://s3-us-west-2.amazonaws.com/contest.fanup.io/ios.png" alt="" />
                                    </a>
                                </div>
                                <div className="android">
                                    <a href="http://bit.ly/2D6HQan">
                                        <img src="https://s3-us-west-2.amazonaws.com/contest.fanup.io/android.png" alt="" />
                                    </a>
                                </div>
                            </div>
                        }
                        { nonWinner && // non-winner
                            <div className="daznInnerWrap">
                                <h1 className="nonWinnerHeader">{headerCopy !== undefined && headerCopy !== null && headerCopy !== "null" ? headerCopy : ' '}</h1>
                                <div className="nonWinnerUnderline" />
                                <h1 className="nonWinnerPrizeCopy">{offerCopy !== undefined && offerCopy !== null && offerCopy !== "null" ? offerCopy : ' '}</h1>
                                <div className="nonWinnerRedeemCopy">
                                    {_parseCopy(directionsCopy)}
                                </div>
                                <div className="nonWinnerLogo">
                                    <img src={"https://s3-us-west-2.amazonaws.com/contest.fanup.io/dazn.png"} alt="" />
                                </div>
                                <div className="nonWinnerLocationCopy">
                                    {_parseCopy(locationCopy)}
                                </div>
                                <div className="ios">
                                    <a href="https://apple.co/2Ubz68u">
                                        <img src="https://s3-us-west-2.amazonaws.com/contest.fanup.io/ios.png" alt="" />
                                    </a>
                                </div>
                                <div className="android">
                                    <a href="http://bit.ly/2D6HQan">
                                        <img src="https://s3-us-west-2.amazonaws.com/contest.fanup.io/android.png" alt="" />
                                    </a>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default DAZNCongrats;



// WEBPACK FOOTER //
// ./src/components/DAZNCongrats.js